import { useMutation } from "@apollo/client";
import {
  CheckoutSessionData,
  GET_ACCOUNT_QUERY,
  POST_CHECKOUT_SESSION,
} from "../../api/Requests";
import { useMemo } from "react";
import client from "../../api/ApiClient";
import styles from "./UpgradeSubscription.module.css";
import { PiConfettiThin } from "react-icons/pi";
import { Link } from "react-router-dom";

interface UpgradeSubscriptionProps {
  priceId: string;
}

export default function UpgradeSubscription({
  priceId,
}: UpgradeSubscriptionProps) {
  const [upgradeSessionCreate, { data, loading, error }] =
    useMutation<CheckoutSessionData>(POST_CHECKOUT_SESSION);

  useMemo(() => {
    if (priceId) {
      return upgradeSessionCreate({
        variables: {
          input: {
            priceId,
            isUpgrade: true,
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [priceId]);

  if (loading) {
    return (
      <div className={styles.subInfo}>
        <p>Updating Subscription...</p>
      </div>
    );
  }
  if (error) {
    return <p>Error: {error.message}</p>;
  }

  if (data?.checkoutSession.status === "active") {
    // Force a refetch of the account data after the subscription is created
    client.refetchQueries({
      include: [GET_ACCOUNT_QUERY],
    });
  }

  return (
    <div className={styles.subInfo}>
      {data?.checkoutSession.status === "active" ? (
        <div>
          <h1>You have successfully upgraded your subscription!</h1>
          <h2>
            <PiConfettiThin /> Thank you for your purchase.
          </h2>
          <p>
            <Link to="/info">
              Get started by importing some information for your Webpage
            </Link>
          </p>
          <p>
            <Link to="/webpage#top">Edit Your Webpage</Link>
          </p>
          <p>
            <Link to="/settings">Publish Your Webpage</Link>
          </p>
        </div>
      ) : (
        <div>
          <h1>Subscription failed</h1>
          <h2>Please contact support to finish subscription process.</h2>
          <p>Upgrade Status: {data?.checkoutSession.status}</p>
        </div>
      )}
    </div>
  );
}
